<script lang="ts">
  import { type Option } from '@components/fields/Schema';

  export let id = '';
  export let className = '';
  export let required = false;
  export let label = '';
  export let description = '';
  export let secondaryDescription = '';
  export let options: Option[] = [];
  export let defaultStyle = false;
  export let error = '';
  export let changed: (value: boolean) => void;

  const handleChange = (index: number) => {
    if (changed) {
      changed(!options[index].checked);
    }
  };
</script>

<div
  class="up-form-element {id} {error ? 'error' : ''} radio {className} {defaultStyle
    ? 'up-standard-checkbox'
    : 'up-custom-checkbox'} "
>
  {#if label}
    <label for={id}>
      {@html label}
      {#if required}
        <span class="required">*</span>
      {:else}
        <span class="optional">(optional)</span>
      {/if}
    </label>
  {/if}

  <div class="up-custom-checkbox__wrapper">
    {#each options as option, index}
      <div class="up-custom-checkbox__input">
        <input
          class="up-checkbox-default"
          {required}
          type="checkbox"
          id={option.value}
          name={id}
          value={option.value}
          checked={option.checked}
          onchange={() => handleChange(index)}
        />

        {#if !defaultStyle}
          <div class="up-custom-checkbox__input__display">
            <svg
              width="18"
              height="12"
              viewBox="0 0 18 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.1456 0.3473C16.8953 0.106462 16.4894 0.106462 16.239 0.3473L5.84804 10.3445L1.76095 6.41226C1.51065 6.17139 1.10476 6.17139 0.854401 6.41226C0.604075 6.65309 0.604075 7.04357 0.854401 7.28444L5.39482 11.6528C5.64505 11.8935 6.05107 11.8936 6.30136 11.6528L17.1456 1.21949C17.3959 0.978616 17.3959 0.588139 17.1456 0.3473Z"
                fill="white"
              ></path>
            </svg>
          </div>
        {/if}
        <div class="flex flex-col">
          <label for={option.value}><span>{option.label}</span></label>
          <span class="mt-2"></span>
          {#if description}
            <p class="up-form-element__description">{description}</p>
          {/if}
        </div>
      </div>
    {/each}

    {#if secondaryDescription}
      <div class="up-custom-checkbox__input">
        <input
          class="up-checkbox-default"
          type="checkbox"
          id={id + '_secondary'}
          name={id + '_secondary'}
          onchange={() => changed(false)}
        />
        {#if !defaultStyle}
          <div class="up-custom-checkbox__input__display">
            <svg
              width="18"
              height="12"
              viewBox="0 0 18 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.1456 0.3473C16.8953 0.106462 16.4894 0.106462 16.239 0.3473L5.84804 10.3445L1.76095 6.41226C1.51065 6.17139 1.10476 6.17139 0.854401 6.41226C0.604075 6.65309 0.604075 7.04357 0.854401 7.28444L5.39482 11.6528C5.64505 11.8935 6.05107 11.8936 6.30136 11.6528L17.1456 1.21949C17.3959 0.978616 17.3959 0.588139 17.1456 0.3473Z"
                fill="white"
              ></path>
            </svg>
          </div>
        {/if}
        <p class="up-form-element__description">{secondaryDescription}</p>
      </div>
    {/if}
  </div>

  {#if error.length > 0}
    <div class="up-form-element__validation-message">{error}</div>
  {/if}
</div>
